import { lazy } from "react";

export const PageViewService = lazy(() => import("./Service"));
